export const LOGIN_BEGIN = "LOGIN_BEGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const REGISTER_BEGIN = "REGISTER_BEGIN";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const SET_FORM_STATUS = "SET_FORM_STATUS";

export const LOGOUT_USER = "LOGOUT_USER";

//Dashboard / form
export const GET_FORM_LIST_BEGIN = "GET_FORM_LIST_BEGIN";
export const GET_FORM_LIST_SUCCESS = "GET_FORM_LIST_SUCCESS";
export const GET_FORM_LIST_ERROR = "GET_FORM_LIST_ERROR";

export const SELECTED_LIST_BEGIN = "SELECTED_LIST_BEGIN";
export const SELECTED_LIST_SUCCESS = "SELECTED_LIST_SUCCESS";
export const SELECTED_LIST_ERROR = "SELECTED_LIST_ERROR";

export const TOGGLE_SELECT_BEGIN = "TOGGLE_SELECT_BEGIN";
export const TOGGLE_SELECT_SUCCESS = "TOGGLE_SELECT_SUCCESS";
export const TOGGLE_SELECT_ERROR = "TOGGLE_SELECT_ERROR";

export const SET_SELECTED_PROFILE = "SET_SELECTED_PROFILE";

// Profile
export const GET_PROFILE_BEGIN = "GET_PROFILE_BEGIN";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_ERROR = "GET_PROFILE_ERROR";

export const UPDATE_PROFILE_BEGIN = "UPDATE_PROFILE_BEGIN";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";

export const DELETE_BROTHER_BEGIN = "DELETE_BROTHER_BEGIN";
export const DELETE_BROTHER_SUCCESS = "DELETE_BROTHER_SUCCESS";
export const DELETE_BROTHER_ERROR = "DELETE_BROTHER_ERROR";

export const DELETE_SISTER_BEGIN = "DELETE_SISTER_BEGIN";
export const DELETE_SISTER_SUCCESS = "DELETE_SISTER_SUCCESS";
export const DELETE_SISTER_ERROR = "DELETE_SISTER_ERROR";

export const DELETE_OTHER_IMG_BEGIN = "DELETE_OTHER_IMG_BEGIN";
export const DELETE_OTHER_IMG_SUCCESS = "DELETE_OTHER_IMG_SUCCESS";
export const DELETE_OTHER_IMG_ERROR = "DELETE_OTHER_IMG_ERROR";

//basic
export const GET_CAST_BEGIN = "GET_CAST_BEGIN";
export const GET_CAST_SUCCESS = "GET_CAST_SUCCESS";
export const GET_CAST_ERROR = "GET_CAST_ERROR";

export const GET_COUNTY_BEGIN = "GET_COUNTY_BEGIN";
export const GET_COUNTY_SUCCESS = "GET_COUNTY_SUCCESS";
export const GET_COUNTY_ERROR = "GET_COUNTY_ERROR";

export const GET_STATE_BEGIN = "GET_STATE_BEGIN";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_ERROR = "GET_STATE_ERROR";

export const GET_CITY_BEGIN = "GET_CITY_BEGIN";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_ERROR = "GET_CITY_ERROR";

export const GET_RELIGION_BEGIN = "GET_RELIGION_BEGIN";
export const GET_RELIGION_SUCCESS = "GET_RELIGION_SUCCESS";
export const GET_RELIGION_ERROR = "GET_RELIGION_ERROR";

export const GET_MARITIALSTATUS_BEGIN = "GET_MARITIALSTATUS_BEGIN";
export const GET_MARITIALSTATUS_SUCCESS = "GET_MARITIALSTATUS_SUCCESS";
export const GET_MARITIALSTATUS_ERROR = "GET_MARITIALSTATUS_ERROR";

export const GET_FILTER_MARITIALSTATUS_BEGIN =
  "GET_FILTER_MARITIALSTATUS_BEGIN";
export const GET_FILTER_MARITIALSTATUS_SUCCESS =
  "GET_FILTER_MARITIALSTATUS_SUCCESS";
export const GET_FILTER_MARITIALSTATUS_ERROR =
  "GET_FILTER_MARITIALSTATUS_ERROR";
